import { Pipe, PipeTransform } from '@angular/core';

import { PipeFunctions } from './_pipe.functions';

@Pipe({
    name: 'bytes2Kilo',
    standalone: false
})
export class ByteToKiloPipe implements PipeTransform {

    transform(raw: number): string {
        return PipeFunctions.bytesToKilo(raw);
    }

}

@Pipe({
    name: 'bytes2Mega',
    standalone: false
})
export class ByteToMegaPipe implements PipeTransform {

    transform(raw: number): string {
        return PipeFunctions.bytesToMega(raw);
    }

}

@Pipe({
    name: 'bytes2HumanReadable',
    standalone: false
})
export class ByteToHumanReadablePipe implements PipeTransform {

    transform(raw: number): string {
        return PipeFunctions.bytesToHumanReadable(raw);
    }

}
